export default __webpack_public_path__ + "static/media/buttonIcon.ddc31a41.png";